/* eslint-disable no-else-return */
export function searchForReadDB(component) {
  const parentComponent = component.parent();
  if (parentComponent !== undefined) {
    if (parentComponent.attributes.sluglofty
      && (
        parentComponent.attributes.sluglofty?.includes('ReadDBContainer')
        || parentComponent.attributes?.sluglofty === 'threeSwiperComponent'
        || parentComponent.attributes?.sluglofty === 'singleDynamicCarouselComponent'
      )
    ) {
      return parentComponent;
    } else {
      return searchForReadDB(parentComponent);
    }
  } else if (parentComponent === undefined) {
    return null;
  } else {
    return searchForReadDB(parentComponent);
  }
}

export function searchForReadDBRefurbished(component) {
  const parentComponent = component.parent();
  if (parentComponent !== undefined) {
    if (parentComponent.attributes.sluglofty
      && (parentComponent.attributes?.sluglofty === 'threeSwiperComponent'
        || parentComponent.attributes?.sluglofty === 'singleDynamicCarouselComponent'
      )
    ) {
      return parentComponent;
    } else if (parentComponent.attributes.sluglofty?.includes('ReadDBContainer')) {
      // Check if its parent is the new Read Component
      const coreComponent = parentComponent.parent();
      if (coreComponent.attributes?.sluglofty === 'readerCoreContainer') {
        return coreComponent;
      } else {
        return parentComponent;
      }
    } else {
      return searchForReadDB(parentComponent);
    }
  } else if (parentComponent === undefined) {
    return null;
  } else {
    return searchForReadDB(parentComponent);
  }
}

export function exhaustiveSearchReadDB(component, seekerData) {
  const parentComponent = component.parent();
  if (parentComponent !== undefined) {
    if (parentComponent.attributes.sluglofty && parentComponent.attributes?.sluglofty?.includes('ReadDBContainer')) {
      seekerData.push(
        {
          idDatabse: parentComponent.attributes.dbSelect,
          idEndpoint: parentComponent.attributes.endpointSelect,
        },
      );
      return exhaustiveSearchReadDB(parentComponent, seekerData);
    } else {
      return exhaustiveSearchReadDB(parentComponent, seekerData);
    }
  } else if (parentComponent === undefined) {
    return seekerData;
  } else {
    return exhaustiveSearchReadDB(parentComponent, seekerData);
  }
}

export function searchForCartCarousel(component) {
  const parentComponent = component.parent();
  if (parentComponent !== undefined && parentComponent.attributes.sluglofty?.includes('carouselCartViewer')) {
    return parentComponent;
  } else if (parentComponent === undefined) {
    return null;
  } else {
    return searchForCartCarousel(parentComponent);
  }
}

// GOAL: Find first a ReadDBContainer, and then cartItemInfoRender to allow button function

export function searchForCartItemRender(component) {
  const parentComponent = component.parent();
  if (parentComponent !== undefined && parentComponent.attributes.sluglofty?.includes('cartItemInfoRender')) {
    return true;
  } else if (parentComponent === undefined) {
    return false;
  } else {
    return searchForCartItemRender(parentComponent);
  }
}

export function searchForReaderAndCartCarousel(component) {
  const parentComponent = component.parent();
  if (parentComponent !== undefined && parentComponent.attributes.sluglofty?.includes('ReadDBContainer')) {
    return searchForCartItemRender(parentComponent);
  } else if (parentComponent === undefined) {
    return false;
  } else {
    return searchForReaderAndCartCarousel(parentComponent);
  }
}

export function searchParentComponentForFields(component) {
  let retVal = [];
  const parentComponent = component.parent();
  if (parentComponent.attributes.sluglofty?.includes('ReadDBContainer')) {
    const componentData = parentComponent.get('components');
    let searcher = '';
    componentData.every((index) => {
      if (index.attributes.sluglofty === 'itemListEndpointDatabase') {
        searcher = 'list';
        return false;
        // eslint-disable-next-line no-else-return
      } else if (index.attributes.sluglofty === 'fieldDatabaseContainer') {
        searcher = 'fields';
        return false;
      } else {
        return true;
      }
    });
    let fieldContainer = [];
    let selectFields = [];
    switch (searcher) {
      case 'list':
        fieldContainer = componentData.filter((index) => (index.attributes.sluglofty === 'itemListEndpointDatabase'));
        fieldContainer[0].attributes.components.models.forEach(
          (index) => {
            selectFields.push({value: index.attributes.valuelofty, name: index.attributes.name});
          },
        );
        break;
      case 'fields':
        fieldContainer = componentData.filter((index) => (index.attributes.sluglofty === 'fieldDatabaseContainer'));
        fieldContainer.forEach(
          (index) => {
            selectFields.push({value: index.attributes.valuelofty, name: index.attributes.name});
          },
        );
        break;
      default:
        fieldContainer = null;
        selectFields = null;
    }
    retVal = selectFields;
  } else {
    const res = searchForReadDB(parentComponent);
    if (res !== undefined && res !== null) {
      const componentData = res.get('components');
      let searcher = '';
      componentData.every((index) => {
        if (index.attributes.sluglofty === 'itemListEndpointDatabase') {
          searcher = 'list';
          return false;
          // eslint-disable-next-line no-else-return
        } else if (index.attributes.sluglofty === 'fieldDatabaseContainer') {
          searcher = 'fields';
          return false;
        } else {
          return true;
        }
      });
      let fieldContainer = [];
      let selectFields = [];
      switch (searcher) {
        case 'list':
          fieldContainer = componentData.filter((index) => (index.attributes.sluglofty === 'itemListEndpointDatabase'));
          fieldContainer[0].attributes.components.models.forEach(
            (index) => {
              selectFields.push({value: index.attributes.valuelofty, name: index.attributes.name});
            },
          );
          break;
        case 'fields':
          fieldContainer = componentData.filter((index) => (index.attributes.sluglofty === 'fieldDatabaseContainer'));
          fieldContainer.forEach(
            (index) => {
              selectFields.push({value: index.attributes.valuelofty, name: index.attributes.name});
            },
          );
          break;
        default:
          fieldContainer = null;
          selectFields = null;
      }
      retVal = selectFields;
    }
  }
  return retVal;
}
